import React, { Component } from 'react';

export default class Home extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="Content Home-Content">
        <div className="Block">

          <div className="Banner">
            <img src={require("../img/Home/Banner-Home.jpg")}/>
            <img src={require("../img/Home/Banner-Home-Mobile.png")}/>
          </div>

          <div className="Info">

            <div>
              <h1> SOBRE ESSE GUIA </h1>

              <p> O Guia de Posicionamento Brasal nasceu para unificar o discurso
              da marca e formalizar a parte de IDENTIDADE que contém os pontos mais
              importantes da sua proposta de valor para o mercado, para a comunidade
              e para seus colaboradores. Passa a ser uma ferramenta indispensável, de
              hoje em diante, para todas as ações e contatos feitos em nome da marca Brasal
              com todos os seus públicos estratégicos. </p>

              <p> Seu resultado nasceu de um estudo aprofundado envolvendo os líderes da marca,
              clientes atuais e potenciais e os mais relevantes players do segmento. Da
              análise deste estudo, nasceram as principais DIRETRIZES VERBAIS E VISUAIS que
              irão conduzir a comunicação da Brasal para os próximos anos. </p>

              <p>Discursos da área comercial, apresentações institucionais, promocionais, anúncios publicitários,
              posts em redes sociais, comunicados internos. Todos estes pontos de contato e muitos outros poderão
              ter neste Guia sua principal referência para que os esforços de comunicação da marca sejam concentrados
              para um mesmo fim: <strong>a construção de uma marca cada vez mais forte.</strong> </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js